import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import Bugsnag from "../utils/bugsnag";
import { identifyUser, resetUser } from "../utils/mixpanel";

const AuthSetup = ({ children }) => {
  const { isAuthenticated, isLoading, user } = useAuth0();

  useEffect(() => {
    if (isLoading) {
      return;
    }

    if (isAuthenticated && user) {
      if (Bugsnag) {
        Bugsnag.setUser(null, user.email, null);
      }

      if (user) {
        identifyUser(user);
      }
    } else {
      if (Bugsnag) {
        Bugsnag.setUser(null, null, null);
      }

      resetUser();
    }
  }, [isAuthenticated, isLoading, user]);

  return children;
};

export default AuthSetup;
